import type { ObjectValues } from '@/types'

export enum EditionStage {
  beforeCampaign = 'beforeCampaign underway',
  beforeCampaignSecure = 'beforeCampaignSecure underway',
  campaignUnderway = 'Campaign underway',
  afterCampaignSecure = 'afterCampaignSecure underway',
  afterCampaign = 'afterCampaign underway',
  betweenCampaign = 'betweenCampaign underway'
}

export type EditionStageType = ObjectValues<typeof EditionStage>
